import { Component, OnInit } from '@angular/core';
import { ContentTableType } from '../shared/enums/content-table-type';
import { LocalStorageService } from '../shared/services/helpers/local-storage.service';
import { ContentTypeRouterPaths } from 'src/app/shared/enums/content-type-router-paths';
import { ContentTypes } from 'src/app/shared/enums/content-types';
import { FeatureFlagsService } from 'src/app/core/feature-flags/feature-flag.service';
import { Features } from 'src/app/core/feature-flags/features';
import { Observable, tap } from 'rxjs';
import { UserRolesService } from 'src/app/shared/services/user-roles.service';
import { USER_ROLES } from 'src/app/core/constants/cms-user-roles';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  cmsUrl = '';
  activeTab = '';

  public contentTableType = ContentTableType;
  CONTENT_TYPE_ROUTER_PATH = ContentTypeRouterPaths;
  public contentTypes = ContentTypes;
  isSingleSponsorFeatureEnabled$: Observable<boolean>;
  isContentSetFeatureEnabled$: Observable<boolean>;
  canWriteArticles$: Observable<boolean>;
  canSubEdit$: Observable<boolean>;

  constructor(
    private localStorageService: LocalStorageService,
    private featureFlagService: FeatureFlagsService,
    private userRolesService: UserRolesService
  ) {}

  ngOnInit(): void {
    this.isSingleSponsorFeatureEnabled$ =
      this.featureFlagService.isFeatureEnabledForUser$(Features.SINGLE_SPONSOR);
    this.isContentSetFeatureEnabled$ =
      this.featureFlagService.isFeatureEnabledForUser$(Features.CONTENT_SET);

    this.canWriteArticles$ = this.userRolesService.isUserInRole(
      USER_ROLES.CanWriteArticles
    );

    this.canSubEdit$ = this.userRolesService
      .isUserInRole(USER_ROLES.CanSubedit)
      .pipe(
        tap(
          (_) =>
            (this.activeTab = this.localStorageService.getActiveDashboard())
        )
      );
  }

  onTabChange(index: number) {
    this.localStorageService.setActiveDashboard(index.toString());
  }
}
